import { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { DataGridPremium as DataGrid, GridColDef } from '@mui/x-data-grid-premium';
import { DecisionVaultMatterObject_FieldsFragment, Estate } from 'queries';

type Props = {
  mattersData: DecisionVaultMatterObject_FieldsFragment[];
  isLoading: boolean;
  setSelectedMatterIds: (matterIds: string[]) => void;
  selectedEstate?: Estate;
};

export const SyncDecisionVaultModalFormSearchResultGrid = ({
  mattersData,
  isLoading,
  setSelectedMatterIds,
  selectedEstate,
}: Props) => {
  const [rowSelectionModel, setRowSelectionModel] = useState<string[]>([]);

  const memoizedColumns = useMemo(() => {
    const columns: GridColDef<DecisionVaultMatterObject_FieldsFragment>[] = [];

    columns.push({
      flex: 2,
      field: 'matter',
      disableColumnMenu: true,
      renderCell: ({ row }) => {
        return <div>{row.matterName}</div>;
      },
    });

    return columns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mattersData]);

  return (
    <Box>
      <DataGrid
        loading={isLoading}
        columns={memoizedColumns}
        rows={mattersData}
        getRowId={(row) => row.matterId}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(selectedRows) => {
          const newSelection =
            selectedEstate && selectedRows.length > 0
              ? [selectedRows[selectedRows.length - 1]]
              : selectedRows;
          setRowSelectionModel(newSelection as string[]);
          setSelectedMatterIds(newSelection as string[]);
        }}
        checkboxSelection
        disableColumnReorder
        disableRowSelectionOnClick
        disableColumnMenu
        columnHeaderHeight={0}
        autoHeight
        pagination
        initialState={{
          pagination: { paginationModel: { pageSize: 25 } },
        }}
      />
    </Box>
  );
};
